import Base from '@studiometa/js-toolkit';

let isScriptLoaded = false;
let scriptPromise = null;

/**
 * Load Youtube Iframe API Sript
 */
function useYoutubeIframeAPi() {
  if (isScriptLoaded) {
    return Promise.resolve(window.YT);
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve) => {
    window.onYouTubeIframeAPIReady = () => {
      isScriptLoaded = true;
      resolve(window.YT);
      delete window.onYouTubeIframeAPIReady;
      // Garbage collector
      scriptPromise = null;
    };
    const script = document.createElement('script');
    script.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.querySelectorAll('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  });

  return scriptPromise;
}

/**
 * Video component
 */
export default class YoutubePlayer extends Base {
  /**
   * Component Configuration
   */
  get config() {
    return {
      name: 'YoutubePlayer',
      isReady: false,
    };
  }

  /**
   * Loaded hook
   */
  async loaded() {
    const Youtube = await useYoutubeIframeAPi();
    this.Youtube = Youtube;
    this.player = new Youtube.Player(this.$refs.player, {
      videoId: this.$options.videoId,
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange,
      },
    });
  }

  /**
   * Youtube PLayer ready event
   */
  onPlayerReady() {
    this.isReady = true;
  }

  /**
   * Youtube Player Overlay click handler
   */
  onOverlayClick() {
    if (!this.isReady) {
      return;
    }

    this.player.playVideo();
    this.$el.classList.add('is-playing');
  }

  /**
   * When player change state
   *
   * BUFFERING: 3
   * UNSTARTED: -1
   * CUED: 5
   * ENDED: 0
   * PAUSED: 2
   * PLAYING: 1
   * @param {object} evetn the native Event
   */
  onPlayerStateChange(event) {
    if (
      event.data === this.Youtube.PlayerState.PAUSED ||
      event.data === this.Youtube.PlayerState.ENDED
    ) {
      this.$el.classList.remove('is-playing');
    }
  }
}
